import ListTags from "../ListTags";
import artist_splash_flashback from "../../assets/fallback/artist_splash_fallback.webp";
import Badge from "../Badge";

const BandMiniProfile = ({ band }) => {
  const altText = "Profilbild för " + band.name;
  const bandUrl = `/music/${band.slug}`;
  const bandTypeUrl = `/discover/${band.constellation_type.toLowerCase()}`;
  const bgImage =
    band.image_splash || band.image_profile || artist_splash_flashback;

  if (band) {
    return (
      <a
        href={bandUrl}
        className="relative group block rounded-2xl h-80 overflow-hidden border border-white/10 shadow-lg transition-all duration-300 hover:scale-[1.02] hover:border-white/20"
      >
        {/* Background image */}
        <img
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          src={bgImage}
          alt={altText}
        />

        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#131313] via-[#131313]/55 to-transparent" />

        {/* Type badge */}
        <div className="absolute top-3 right-3 z-10">
          <Badge text={band.constellation_type} type="band-type" />
        </div>

        {/* Bottom content */}
        <div className="absolute bottom-0 left-0 right-0 z-10 p-5">
          <h4 className="font-extrabold text-xl text-white uppercase tracking-wide truncate mb-1">
            {band.name}
          </h4>
          {band.description && (
            <p className="text-xs text-stone-300 line-clamp-2 mb-3 leading-relaxed">
              {band.description}
            </p>
          )}
          <div className="flex flex-wrap gap-1 overflow-hidden max-h-8">
            <ListTags
              mainTags={band.genre_main}
              subTags={band.genre_sub}
              direction="row"
            />
          </div>
        </div>
      </a>
    );
  }
};

export default BandMiniProfile;
